import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";

import { SharedModule } from "../shared/shared.module";
import { SignInWithUsernameComponent } from "./sign-in-with-username/sign-in-with-username.component";

import { routing } from "./auth.routing";
import { ConfirmPasswordComponent } from "./confirm-password/confirm-password.component";
import { ConfirmPasswordGuard } from "./confirm-password/guards/confirm-password.guard";
import { TermsConditionsComponent } from "./terms-conditions/terms-conditions.component";
import { TermsConditionsTextComponent } from "./terms-conditions-text/terms-conditions-text.component";
import { MfaActivationComponent } from "./mfa-activation/mfa-activation.component";
import { MfaEntryComponent } from "./mfa-entry/mfa-entry.component";
import { SignInComponent } from "./sign-in/sign-in.component";
import { ProblemComponent } from "./problem/problem.component";
import { UnknownProblemComponent } from "./unknown-problem/unknown-problem.component";
import { MustSetMainFunctionProblemComponent } from "./must-set-main-function-problem/must-set-main-function-problem.component";
import { IonHeader } from "@ionic/angular/standalone";
import { AppSunsetBannerComponent } from "../app/app-sunset-banner.component";

@NgModule({
	imports: [SharedModule, MatDialogModule, IonHeader, AppSunsetBannerComponent],
	declarations: [
		SignInWithUsernameComponent,
		ConfirmPasswordComponent,
		TermsConditionsComponent,
		TermsConditionsTextComponent,
		MfaActivationComponent,
		MfaEntryComponent,
		SignInComponent,
		ProblemComponent,
		UnknownProblemComponent,
		MustSetMainFunctionProblemComponent,
	],
	exports: [
		SignInWithUsernameComponent,
		ConfirmPasswordComponent,
		TermsConditionsComponent,
		TermsConditionsTextComponent,
		MfaActivationComponent,
		MfaEntryComponent,
		SignInComponent,
		ProblemComponent,
		UnknownProblemComponent,
		MustSetMainFunctionProblemComponent,
	],
})
export class AuthSharedModule {}

@NgModule({
	imports: [SharedModule, MatDialogModule, AuthSharedModule, routing],
	providers: [ConfirmPasswordGuard],
})
export class AuthModule {}
